import { useT } from '@insurensa/i18n';

/**
 * Branded loading state for the app shell.
 *
 * Centred on the viewport over a softened backdrop. In-page loading of a
 * table or panel uses BlockSkeleton instead, which holds the shape of the
 * content being waited on.
 *
 * The 160ms fade-in lives in CSS rather than a timer here, so no state is
 * needed and the component stays cheap to mount and unmount.
 */
export function AppLoader({ label }: { label?: string }): JSX.Element {
  const t = useT();

  return (
    <div
      className="app-loader"
      role="status"
      aria-live="polite"
    >
      <div className="app-loader__card">
        {/* Decorative: the status text below carries the meaning. */}
        <img className="app-loader__mark" src="/theme/assets/images/logo.png" alt="" />
        <span className="app-loader__track">
          <span className="app-loader__bar" />
        </span>
        <span className="sr-only">{label ?? t('common.loading')}</span>
      </div>
    </div>
  );
}
